import { useAppTheme } from '@shared-ui/theme'
import Svg, { Path } from 'react-native-svg'

type Props = {
  size?: number
  color?: string
}

export function AppIconChatsOutline({ size = 20, color }: Props) {
  const theme = useAppTheme()
  const fill = color ?? theme.COLOR_TEXT_PRIMARY

  return (
    <Svg width={size} height={size} viewBox="2 2 20 20" fill="none">
      <Path
        fill={fill}
        d="M19.8563 6.681C19.8563 5.6291 19.004 4.7768 17.9522 4.7768H6.0479C4.996 4.7768 4.1437 5.6291 4.1437 6.681V14.6176C4.1439 15.6693 4.9961 16.5217 6.0479 16.5217H7.0395C7.6312 16.5217 8.1114 17.0019 8.1114 17.5936V18.6771L11.449 16.6741L11.578 16.6089C11.7109 16.5519 11.8544 16.5217 12 16.5217H17.9522C19.0039 16.5217 19.8561 15.6693 19.8563 14.6176V6.681ZM12.2766 11.6648C12.868 11.6651 13.3472 12.1442 13.3474 12.7355C13.3474 13.327 12.8682 13.807 12.2766 13.8074H7.0384C6.4467 13.8074 5.9665 13.3272 5.9665 12.7355C5.9667 12.1439 6.4468 11.6648 7.0384 11.6648H12.2766ZM9.4192 7.0449C10.0107 7.0451 10.4899 7.5252 10.4899 8.1168C10.4899 8.7083 10.0107 9.1884 9.4192 9.1886H7.0384C6.4467 9.1886 5.9665 8.7085 5.9665 8.1168C5.9665 7.5251 6.4467 7.0449 7.0384 7.0449H9.4192ZM22 14.6176C21.9998 16.8528 20.1872 18.6643 17.9522 18.6643H12.2975L8.4566 20.9684C8.3332 21.0425 8.1772 21.138 8.037 21.2056C7.9029 21.2701 7.6196 21.3945 7.2639 21.3614C6.8577 21.3234 6.487 21.1125 6.2455 20.7835C6.0344 20.4959 5.9953 20.1902 5.9816 20.042C5.9674 19.8871 5.9688 19.7045 5.9688 19.5606V18.662C3.7702 18.6198 2.0002 16.8264 2 14.6176V6.681C2 4.4457 3.8126 2.6332 6.0479 2.6332H17.9522C20.1874 2.6332 22 4.4457 22 6.681V14.6176Z"
      />
    </Svg>
  )
}
